export function simpleTextFieldUpgrade(cimDoc) {
    /* eslint-disable no-param-reassign */
    for (const panel of cimDoc.document.panels) {
        const convertedTextAreas = [];
        if (panel.simpleTextFields) {
            for (const simpleTextField of panel.simpleTextFields) {
                convertedTextAreas.push(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ id: simpleTextField.id, position: simpleTextField.position, zIndex: simpleTextField.zIndex, rotationAngle: simpleTextField.rotationAngle }, (!!simpleTextField.horizontalAlignment && {
                    horizontalAlignment: simpleTextField.horizontalAlignment,
                })), (!!simpleTextField.verticalAlignment && {
                    verticalAlignment: simpleTextField.verticalAlignment,
                })), (!!simpleTextField.textOrientation && { textOrientation: simpleTextField.textOrientation })), (!!simpleTextField.blockFlowDirection && {
                    blockFlowDirection: simpleTextField.blockFlowDirection,
                })), { content: [
                        Object.assign(Object.assign({ content: simpleTextField.content, fontFamily: simpleTextField.fontFamily, fontSize: simpleTextField.fontSize, fontStyle: simpleTextField.fontStyle, color: simpleTextField.color }, (!!simpleTextField.inlineBaseDirection && {
                            inlineBaseDirection: simpleTextField.inlineBaseDirection,
                        })), (!!simpleTextField.overprints && { overprints: simpleTextField.overprints })),
                    ] }));
            }
            if (!panel.textAreas) {
                panel.textAreas = [];
            }
            panel.textAreas = panel.textAreas.concat(convertedTextAreas);
            delete panel.simpleTextFields;
        }
    }
    /* eslint-enable no-param-reassign */
    return cimDoc;
}
//# sourceMappingURL=simpleTextFieldUpgrade.js.map